import { useEffect, useState } from "react";

/**
 * Returns the remote image URL only after it has loaded successfully.
 * Returns undefined while pending or on error so callers can show a profile placeholder.
 */
export function usePreloadedLogo(
  remoteUrl?: string | null
): string | undefined {
  const [displaySrc, setDisplaySrc] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!remoteUrl) {
      setDisplaySrc(undefined);
      return;
    }

    setDisplaySrc(undefined);

    let cancelled = false;
    const img = new window.Image();
    img.onload = () => {
      if (!cancelled) {
        setDisplaySrc(remoteUrl);
      }
    };
    img.onerror = () => {
      if (!cancelled) {
        setDisplaySrc(undefined);
      }
    };
    img.src = remoteUrl;

    return () => {
      cancelled = true;
    };
  }, [remoteUrl]);

  return displaySrc;
}
